import '@nutrien/ddc-components/dist/style.css';
import './root.css';

import { DDCComponents, lightTheme } from '@nutrien/ddc-components';
import { PwaLogging } from '@nutrien/ddc-fe-logging-pwa';
import { identifierManagerContext, loggingContext } from '@nutrien/ddc-fe-logging-react-router-dom';
import { FC } from 'react';

import { DemoSchema } from '../../schema';
import { App } from '../App/App';

export interface Props {
  logging: PwaLogging<DemoSchema>;
}

export const Root: FC<Props> = props => {
  return (
    <identifierManagerContext.Provider value={props.logging.identifierManager}>
      <loggingContext.Provider value={props.logging}>
        <DDCComponents theme={lightTheme}>
          <App />
        </DDCComponents>
      </loggingContext.Provider>
    </identifierManagerContext.Provider>
  );
};
